import { Injectable } from '@angular/core';

/** Notifies the loading of dynamic modules to the secured skeleton */
@Injectable({
  providedIn: 'root',
})
export class SecuredDynamicLoadingService {
  /** The message of the module being loaded */
  private loadingModuleMessage: string | null = null;

  /** True if a dynamic module is being loaded */
  get isLoadingDynamicModule(): boolean {
    return this.loadingModuleMessage !== null;
  }

  /** Returns the message to be displayed when a dynamic module is loading */
  get loadingMessage(): string {
    return this.loadingModuleMessage ?? '';
  }

  constructor() {}

  /**
   * Call before a dynamic module is loaded
   * The [SecuredSkeletonComponent] will display the given [message]
   */
  notifyModuleIsLoading(message = 'Loading module') {
    this.loadingModuleMessage = message;
  }

  /**
   * Call after a dynamic module finishes loading or throws an error
   * Will remove the loading message from the [SecuredSkeletonComponent]
   */
  notifyModuleFinishedOrFailedLoading() {
    this.loadingModuleMessage = null;
  }
}
